import { create } from 'zustand';
import type { PostSponParams } from '../types/modal/broadcast/spon/type';

export const DEFAULT_EXCEL_SELECT_VALUE: {
  excelType: PostSponParams['excelType'];
  excelBj: PostSponParams['excelBj'];
} = {
  excelType: 'plus',
  excelBj: -1,
};

interface BroadcastSponPopoverState {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  defaultExcelSelectValue: {
    excelType: PostSponParams['excelType'];
    excelBj: PostSponParams['excelBj'];
  };
  setDefaultExcelSelectValue: (newValue: {
    excelType: PostSponParams['excelType'];
    excelBj: PostSponParams['excelBj'];
  }) => void;
}

export const useBroadcastSponPopoverStore = create<BroadcastSponPopoverState>((set) => ({
  isOpen: false,
  setIsOpen: (open: boolean) => set(() => ({ isOpen: open })),
  defaultExcelSelectValue: DEFAULT_EXCEL_SELECT_VALUE,
  setDefaultExcelSelectValue: (newValue: {
    excelType: PostSponParams['excelType'];
    excelBj: PostSponParams['excelBj'];
  }) => set(() => ({ defaultExcelSelectValue: newValue })),
}));
